<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .cards {
    display: grid;
    gap: utils.in_rem(12px);

    &.is-overlay {
      grid-template-columns: repeat(3, 1fr);
      @media (max-width: 970px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 740px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }

    &:not(.is-overlay) {
      grid-template-columns: repeat(2, 1fr);
      padding-right: utils.in_rem(12px); // keep away from scrollbar
    }
  }
</style>

<script>
  import CompanyInsightsContainer from "../CompanyInsightsContainer.svelte";
  import Filter from "../Filter.svelte";
  import ShowMoreButton from "../ShowMoreButton.svelte";
  import {
    companyInsightsStore,
    isOverlayStore,
    jobTagsStore,
  } from "../stores";
  import { showItem } from "../utils";
  import JobCard from "./JobCard.svelte";

  // For tags filter
  let selectedItems = [];
  let showFilter = false;

  $: showEmptyState =
    !$companyInsightsStore?.jobs || $companyInsightsStore?.jobs.length === 0;

  $: disabled = !$jobTagsStore || $jobTagsStore.length === 0;

  let showingAllItems = false;

  let innerWidth = 0;

  // Shows one row, regardless of screen size
  $: maxItems = innerWidth < 740 ? 1 : innerWidth < 970 ? 2 : 3;

  $: wrappedJobs =
    showingAllItems || !$isOverlayStore
      ? $companyInsightsStore?.jobs
      : $companyInsightsStore?.jobs?.slice(0, maxItems);
</script>

<svelte:window bind:innerWidth />

<!-- Don't render the filter on the overlay if there are no tags -->
{#if !$isOverlayStore || !disabled}
  <Filter
    items={$jobTagsStore}
    bind:selectedItems
    bind:show={showFilter}
    {disabled}
  />
{/if}

<CompanyInsightsContainer {showEmptyState} {showFilter}>
  <div class="cards" class:is-overlay={$isOverlayStore}>
    {#each wrappedJobs as job}
      {#if showItem(job, selectedItems)}
        <JobCard {job} {$isOverlayStore} />
      {/if}
    {/each}
  </div>
  {#if $isOverlayStore && $companyInsightsStore?.jobs.length > maxItems}
    <ShowMoreButton bind:showingMore={showingAllItems} />
  {/if}
  <span slot="noCompanyInfo"> No jobs found </span>
</CompanyInsightsContainer>
